import { MenuProperty, RouteKey } from "../enums";
import { IMenuItem } from "../models";

export const MENU_ITEMS: IMenuItem[] = [
    {
        key: RouteKey.Home,
        icon: "fas fa-home",
        url: "/",
        title: "Anasayfa",
        text: "Yönetilebilecek tüm alanları sol menüde görüntüleyebilirsiniz. Aşağıdan da hızlı işlemlere göz atabilirsiniz."
    },
    {
        key: RouteKey.ContentTypeManagement,
        icon: "fab fa-accusoft",
        url: "/content-types",
        title: "İçerik Tipi Yönetimi",
        text:
            "Dinamik olarak yönetebileceğiniz içerik tiplerini görüntüleyebilirsiniz.",
        properties: [MenuProperty.Frequently]
    },
    {
        key: RouteKey.ContentTypes,
        icon: "fas fa-mask",
        url: "",
        title: "İçerik Tipleri",
        text: "Eklenilen içerik tiplerini aşağıdan yönetin.",
        properties: [MenuProperty.ContentType],
        children: []
    },
    {
        key: RouteKey.ActivityManagement,
        icon: "fas fa-theater-masks",
        url: "/",
        title: "Etkinlik Yönetimi",
        text:
            "Dinamik olarak yönetebileceğiniz etkinlik yönetimlerini görüntüleyebilirsiniz.",
        children: [
            {
                key: RouteKey.Activity,
                icon: "fas fa-mask",
                url: "/activities",
                title: "Etkinlikler",
                text: "Dinamik olarak yönetebileceğiniz etkinlikleri görüntüleyebilirsiniz."
            },
            {
                key: RouteKey.ActivityGroup,
                icon: "fas fa-igloo",
                url: "/activity-groups",
                title: "Etkinlik Grupları",
                text: "Dinamik olarak yönetebileceğiniz grupları görüntüleyebilirsiniz."
            },
            {
                key: RouteKey.ActivityType,
                icon: "fas fa-palette",
                url: "/activity-types",
                title: "Etkinlik Türleri",
                text: "Dinamik olarak yönetebileceğiniz etkinlik türlerini görüntüleyebilirsiniz."
            },
            {
                key: RouteKey.ActivityCommunity,
                icon: "fas fa-palette",
                url: "/activity-communities",
                title: "Etkinlik Toplulukları",
                text: "Dinamik olarak yönetebileceğiniz etkinlik topluluklarını görüntüleyebilirsiniz."
            },
            {
                key: RouteKey.Artist,
                icon: "fas fa-person-booth",
                url: "/artists",
                title: "Sanatçılar",
                text: "Dinamik olarak yönetebileceğiniz sanatçıları görüntüleyebilirsiniz."
            },
            {
                key: RouteKey.ArtistRole,
                icon: "fas fa-user-shield",
                url: "/artist-roles",
                title: "Sanatçı Rolleri",
                text: "Dinamik olarak yönetebileceğiniz sanatçı rollerini görüntüleyebilirsiniz.",
                exclude: true
            },
            {
                key: RouteKey.Place,
                icon: "fas fa-igloo",
                url: "/places",
                title: "Mekanlar",
                text: "Dinamik olarak yönetebileceğiniz mekanları görüntüleyebilirsiniz."
            },
            {
                key: RouteKey.FeaturedActivities,
                icon: "fas fa-mask",
                url: "/featured-activities",
                title: "Öne Çıkan Etkinlikler",
                text: "Dinamik olarak yönetebileceğiniz öne çıkan etkinlikleri görüntüleyebilirsiniz."
            },
        ],
        properties: [MenuProperty.Highlight]
    },
    {
        key: RouteKey.Layout,
        icon: "fas fa-columns",
        url: "/layouts",
        title: "Layout Yönetimi",
        text:
            "İçerik'lerin sahip olduğu varsayılan tasarım yerleşimini ayarlayabilirsiniz. ",
        properties: [MenuProperty.Frequently]
    },
    {
        key: RouteKey.Menu,
        icon: "fas fa-compass",
        url: "/menus",
        title: "Menü Yönetimi",
        text:
            "İçerik'lerin sahip olduğu varsayılan tasarım yerleşimini ayarlayabilirsiniz. ",
        properties: [MenuProperty.Frequently]
    },
    {
        key: RouteKey.Specification,
        icon: "fas fa-star-of-life",
        url: "/specifications",
        title: "Spesifikasyon Yönetimi",
        text:
            "İçerik'lerin sahip olduğu varsayılan tasarım yerleşimini ayarlayabilirsiniz. "
    },
    {
        key: RouteKey.Users,
        icon: "fas fa-users",
        url: "/user",
        title: "Kullanıcı Yönetimi",
    },
    {
        key: RouteKey.Roles,
        icon: "fas fa-user-shield",
        url: "/roles",
        title: "Rol Yönetimi",
    },
    {
        key: "permission",
        icon: "fab fa-affiliatetheme",
        url: "/permission",
        title: "Rol Yönetimi",
        properties: [MenuProperty.Frequently],
    },
    {
        key: RouteKey.ThemeSettings,
        icon: "fab fa-affiliatetheme",
        url: "/theme-settings",
        title: "Tema Ayarları",
        text:
            "Geçerli uygulamanın tüm tema ayarlarını ve görsel özelliklerini yönetebilirsiniz.",
        properties: [MenuProperty.Frequently],
    },
    {
        key: RouteKey.FileManagement,
        icon: "fas fa-cloud",
        url: "",
        title: "Dosya Yönetimi",
        text: "",
        properties: [MenuProperty.FileManager]
    }
]